-Typ<template>
  <div>
    <!--填写完成-->
    <div class="statusBar" v-if="tabLabel>1||formData.room_need.length>0">
      <ul class="fillin">
          <li class="complete"  :class="{'text-active':tabLabel==1}">
              <div @click="switchNeeds(1)" class="content">
                <div> 入住信息</div>
                <div><i class="ml-2" :class="tabLabel==1?'el-icon-arrow-up':'el-icon-arrow-down'"></i></div>
              </div>
          </li>
          <li class="complete" :class="{'text-active':tabLabel==2}">
              <div @click="switchNeeds(2)" class="content">
                <div> 用房需求</div>
                <div><i class=" ml-2" :class="tabLabel==2?'el-icon-arrow-up':'el-icon-arrow-down'"></i></div>
              </div>
          </li>
          <li class="complete"  :class="{'text-active':tabLabel==5}" v-if="requirementList[1].state">
            <el-popconfirm
              placement="top"
              title="是否删除优惠房？"
              @confirm="requirementList[1].state=false;formData.discount_need=[];tabLabel=2"
            >
              <i class="el-icon-delete-solid "  slot="reference"></i>
            </el-popconfirm>
            <div @click="switchNeeds(5)" class="content">
                <div> 优惠房<span class="text-ris"></span></div>
                <div><i class="ml-2" :class="tabLabel==5?'el-icon-arrow-up':'el-icon-arrow-down'"></i></div>
              </div>
                <!-- <el-popconfirm
                  placement="top"
                  title="是否删除优惠房？"
                  @confirm="requirementList[1].state=false;formData.discount_need=[]"
                >
                  <div class="category-item-icon" slot="reference" v-show="tabLabel!=5">
                      <i class="el-icon-close"></i>
                  </div>
                </el-popconfirm> -->
          </li>
          <li class="complete"  :class="{'text-active':tabLabel==3}" v-if="requirementList[0].state" >
              <el-popconfirm
                placement="top"
                title="是否删除会议需求？"
                @confirm="requirementList[0].state=false;formData.meeting_need=[];tabLabel=2"
              >
                <i class="el-icon-delete-solid "  slot="reference"></i>
              </el-popconfirm>
              <div @click="switchNeeds(3)" class="content">
                <div> 会议需求<span class="text-ris"></span></div>
                <div><i class="ml-2" :class="tabLabel==3?'el-icon-arrow-up':'el-icon-arrow-down'"></i></div>
              </div>
              <!-- <el-popconfirm
                placement="top"
                title="是否删除会议需求？"
                @confirm="requirementList[0].state=false;formData.meeting_need=[]"
              >
                <div class="category-item-icon" slot="reference" v-show="tabLabel!=3">
                    <i class="el-icon-close"></i>
                </div>
              </el-popconfirm> -->
          </li>
          <li class="complete"  :class="{'text-active':tabLabel==4}" v-if="requirementList[2].state">
              <el-popconfirm
                placement="top"
                title="是否删除附加需求？"
                @confirm="requirementList[2].state=false;formData.add_need=[];tabLabel=2"
              >
                <i class="el-icon-delete-solid "  slot="reference"></i>
              </el-popconfirm>
              <div @click="switchNeeds(4)" class="content">
                <div> 附加需求<span class="text-ris"></span></div>
                <div><i class="ml-2" :class="tabLabel==4?'el-icon-arrow-up':'el-icon-arrow-down'"></i></div>
              </div>
              <!-- <el-popconfirm
                placement="top"
                title="是否删除附加需求？"
                @confirm="requirementList[2].state=false;formData.add_need=[]"
              >
                <div class="category-item-icon" slot="reference" v-show="tabLabel!=4">
                    <i class="el-icon-close"></i>
                </div>
              </el-popconfirm> -->
          </li>
      </ul>
    </div>
    <!-- 基本信息-入住需求-->
    <roomBasic  :ruleForm="formData" :modify="modify" :orderConfirm="orderConfirm" v-show="tabLabel===1"  ref="roomBasic" :isHotelInquiry="isHotelInquiry"></roomBasic>
    <!--用房需求-->
    <roomType v-show="tabLabel===2" class="mt-3" :room_need_clone="formData.room_need" :modify="modify" ref="roomType"></roomType>
    <!--用房-优惠房-->
    <roomType v-show="tabLabel===5" class="mt-3" :room_need_clone="formData.discount_need" :modify="modify" :discount="true" ref="discount" ></roomType>
    <!--会议需求-->
    <meetingType v-show="tabLabel===3" class="mt-3" :meeting_need="formData.meeting_need" :modify="modify"  ref="meetingType"></meetingType>
    <!--其他需求-->
    <other v-show="tabLabel===4" :add_need="formData.add_need" class=" mt-3" ref="other"></other>
    <!--其他需求开关-->
    <div class="other" v-if="tabLabel>1">
        <p>更多需求</p>
        <ul class="other-list">
          <template v-for="(item,index) in requirementList">
            <li v-if="modify?index>-1:index<1"  :key="item.id" :class="{'other-active':item.state}" @click="switchTabOther(index,item.tabLabel)">{{item.name}}</li>
          </template>
        </ul>
    </div>
    <div class="mt-4">
      <div v-if="tabLabel===1" class="primary-button">
        <el-button :type="formData.room_need.length>0?'success':'primary'" :style="{'width':formData.room_need.length>0?'49%':'100%'}" @click="roomBasicBottom(modify?2:1)"  v-if="!modify||orderConfirm" >
          <span v-if="formData.room_need.length>0">重新生成用房</span>
          <span v-else>下一步、{{modify?'填写':'选择'}}入住房型</span>
        </el-button>
        <el-button type="primary"  @click="submitForm()" :style="modify&&!orderConfirm?'width:100%':'width:49%'" v-if="formData.room_need.length>0" >确认订单</el-button>
      </div>
      <template v-if="tabLabel>1">
        <!-- <el-button @click="back()">返回修改</el-button> -->
        <el-button type="primary"  @click="submitForm()" style="width: 100%;" >确认订单</el-button>
      </template>
    </div>
    <el-dialog
      :visible.sync="roomVisible"
      width="600px"
      title="请选择入住房型"
      top="14%"
      >
      <ul class="choice-Room">
        <li :class="{'choice-active':roomTyle===item.id}" v-for="(item,index) in $GVAR.roomStyle" :key="index" @click="roomTyle=item.id">
          <img :src="roomTyle===item.id?`/images/fx/icon_${index+1}_k.png`:`/images/fx/icon_${index+1}.png`">
          <span>{{item.name}}</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="roomVisible = false">返 回</el-button>
        <el-button :disabled="roomTyle?false:true" type="primary" @click="getRoomType()">确 定</el-button>
      </span>
    </el-dialog>
    <!--批量修改弹窗-->
    <el-dialog  
        title="填写入住房型信息"
        :visible.sync="batchVisible"
        width="800px"
        :close-on-click-modal="false"
        top="12%"
    >
        <BatcDialog :modify="modify" @batchSubmit="item=>batcoffer_info=item" :isSubmit="batcbmit"></BatcDialog>
        <span slot="footer" class="dialog-footer">
            <el-button @click="batchVisible = false">返 回</el-button>
            <el-button type="primary" @click="batchSubmitConfirm()">确 定</el-button>
        </span>
    </el-dialog>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import roomBasic from './Components/roomBasic.vue'                 //基本信息-入住需求
import roomType from './Components/roomType.vue'                   //用房需求
import meetingType from './Components/meetingType.vue'             //会议需求
import other from './Components/other.vue'                         //其他需求
import Temp from '@/views/Admin/FinancialManage/FinancialStats/EchartStat/temp.vue'
import BatcDialog from './Components/Comp/BatcDialog'
import { watch } from 'vue'
export default {
  name: 'Room',
  components: {roomBasic, roomType, meetingType,other,Temp,BatcDialog},
  mounted() {},
  props: {
    //订单详情
    orderDetail: {
      type: Object,
      default: () => {}
    },
    //是否修改订单
    modify: {
      type: Boolean,
      default: false
    },
    //是否询价酒店
    isHotelInquiry: {
      type: Boolean,
      default: false
    },
    //是否确认订单
    orderConfirm: {
      type: Boolean,
      default: false
    },
    //是否是发布确认订单
    orderConfirmSend: {
      type: Boolean,
      default: false
    },
    //是否是代订收款
    behalf: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      orderInfo:{},                                    //修改原生数据
      //表单数据
      formData: {
        order_type: 1,                            //订单类型：1住宿订单、2纯会议订单、
        team_type: 1,                             //团队类型：1旅游团、2会议团
        need_mode:1,                              //多晚入住
        title: '',                                //团号标题
        province:'',                              //目的地省份
        city:'',                                  //目的地城市
        district:[],                              //目的地区县
        star:[],                                  //酒店星级
        date_in: '',                              //入住日期
        date_out:'',                              //离店日期
        num:'',                                   //人数
        breakfast:'',                             //早餐需求
        breakfast_type:'',                        //早餐提供
        room_need: [],                            //房型需求
        meeting_need: [],                         //会议需求
        discount_need:[],                         //优惠房需求
        other:[],                                 //其他需求
        eatery:'',                                //餐饮需求
        remark:'',                                //备注
        add_need:[],                              //附加需求
      },                  
      tabLabel:1,                                 //1：基本信息-入住需求 2：用房需求 3：会议需求、4：其他需求
      returnvalue:false,                          //记录每个每次返回值
      buttonsShow:true,                           //是否显示确认发布订单按钮
      roomVisible:false,                           //弹窗是否显示
      roomTyle:'',                                //生成房型类型
      requirementList:[                           //其他需求分类
          {name:'会议需求',text:'添加会议室预订需求',onText:'是否删除会议需求',state:false,tabLabel:3},
          {name:'优惠房',text:'可以设置优惠房减免总金额',onText:'是否删除优惠房',state:false,tabLabel:5},
          {name:'附加需求',text:'添加会场费、餐费、其他',onText:'是否删除附加需求',state:false,tabLabel:4},
      ],      
      batchVisible:false,                         //批量修改弹窗是否显示
      batcoffer_info:{},                          //批量修改房间类型
      batcbmit:false,                             //开启提示
    };
  },
  computed: {
      ...mapGetters(['storeInfo']),
  },
  watch: {
    orderDetail: {
      handler(newVal, oldVal) {
        this.initModifyOrder(newVal);
      },
      deep: true
    },
    
  },
  created() {
  },
  mounted() {

    //
  },
  methods: {
    //下一步、切换房型需求
    nextStep(e) {
      //已填写完基本信息切换房型需求
      if(this.tabLabel===1){
        this.tabLabel = 2;
        // this.formData=e;
      }
      //如果房型需求为空生成房型需求
      // if(this.formData.room_need.length===0){
      //   this.getRoomType(e);
      // }
      // console.log(e);
    },
    batchSubmitConfirm(){
      this.getRoomType();
    },
    //入住日期、人数、自动生成房型需求
    getRoomType(){
      let e=this.formData;
      let room_need = [];
      const oneDay = 24 * 60 * 60 * 1000;         // 一天的毫秒数
      let date_in = e.date_in[0];                 //开始时间
      let date_out = e.date_in[1];                //结束时间
      let num = e.num;                            //入住人数
      //循环开始-结束时间戳、默认双床房、人数/2向上取整为房间数量
      let type=this.orderConfirmSend?this.batcoffer_info.type:this.roomTyle;
      console.log(type);
      while (date_in <date_out) {
        room_need.push({
          date:date_in,
          offer_info:[
            { 
              offer_price:'',
              offer_id:'',
              offer_title:'',
              breakfast:this.orderConfirm?e.breakfast:'',
              ...this.batcoffer_info, 
              type,
              room_num:Math.ceil( num / this.getNum(type)), 
            },
          ]}
          );
        date_in += oneDay;

      }
      console.log(room_need);
      //生成房型需求时补充早餐提供类型
      if(this.modify){
        this.formData.breakfast=e.breakfast;
        this.formData.breakfast_type=e.breakfast;
      }
      this.formData.room_need = room_need;
      this.buttonsShow = true;
      this.roomVisible = false;
      this.batchVisible = false;
      this.tabLabel = 2;
    },
    //房间类型人数
    getNum(val) {
        const map = {
          1: 1,
          2: 2,
          3: 3,
          4: 3,
          5: 2
        }
        return map[val] ||0
    },
    //切换会议需求
    switchTabMeetings(){
      //判断当前房型是全部填完
      let isSubmit = this.$refs.roomType.submitForm('back');
      //最少一个用房需求添加
      if(isSubmit.room_need.length==0){
        return this.$message.error('请添加一个用房需求');
      }
      if(isSubmit){
        this.tabLabel = 3;
      }
    },
    //切换其他需求
    async switchNeeds(i){
      //判断当前房型是全部填完
      let isSubmit = await this.validateForm(1);
      if(isSubmit){
        this.tabLabel = i;
      }
    },
    //*****************修改订单方法*****************//
    //修改订单初始化
    initModifyOrder(res){
      res=JSON.parse(JSON.stringify(res));       //防止连带
      let Value=this.$_Object.getSecondObjIntersectionValues(this.formData,res);       //只获取交集对象
      Value = this.$_Object.convertCommaValueToArray(Value, false, true);              //带','转为数组
      //酒店修改默认早餐提供
      //需要转数字的字段数组
      const numKeys = ['order_type', 'city', 'province', 'breakfast']
      numKeys.forEach(key => Value[key] = Number(Value[key]));
      //如果是多晚入住时间毫秒转换秒
      // 批量赋值
      res.room_need_arr = this.transformDateArr(res.room_need_arr)
      res.discount_need = this.transformDateArr(res.discount_need_arr)
      res.meeting_need_arr = this.transformDateArr(res.meeting_need_arr)
      Value={
        ...this.formData,
        ...Value,
        order_type:1,                                                          //订单类型
        district:this.$_Array.commaStrToArray(Value.district)||[],             //区转为数组、方便确认单
        star:this.$_Array.commaStrToArray(Value.star)||[],                     //星级转为数组、方便确认单
        other:this.$_Array.commaStrToArray(Value.other)||[],                   //其他需求转为数组、方便确认单
        room_need:this.orderDetail.room_need_arr.mode==0?[]:res.room_need_arr, //房型需求-之前格式默认传空
        breakfast:res.breakfast || res.room_need_arr[0].offer_info[0].breakfast, //早餐提供
        discount_need:res.discount_need,                                         //优惠房需求
        meeting_need:res.meeting_need_arr,                                       //会议需求
        breakfast_type:res.breakfast_type||res.room_need_arr[0].offer_info[0].breakfast,                                     //早餐提供
        add_need:res.add_need_arr.list||[],                                      //附加需求
        date_in:[res.date_in*1000,res.date_out*1000],
      } 
      this.formData = Value;      //赋值给表单数据
      this.orderInfo=JSON.parse(JSON.stringify(Value));       //防止连带-修改原生数据
      if(Value.meeting_need.length>0){
        this.requirementList[0].state=true;
      }
      if(Value.discount_need.length>0){
        this.requirementList[1].state=true;
      }
      if(Value.add_need.length>0){
        this.requirementList[2].state=true;
      }
    },
    //判断是否有会议、优惠房、附加需求
    // 公共处理：提取list并把date秒转毫秒
    transformDateArr(target) {
      // 不存在直接返回原对象兜底
      if (!target || !target.list) return target
      // 遍历转换date
      return target.list.map(item => ({
        ...item,
        date: item.date * 1000
      }))
    },
    //*****************确认订单方法*****************//
    //调用基本信息确认方法
    async roomBasicBottom(i,tabLabel){
      let {isSubmit,formData} = await this.$refs.roomBasic.submitForm();       //调用基本信息确认方法
      this.formData = {...this.formData,...formData};
      if(isSubmit){
        //如果没有房型弹出选着框
        if(i==1){
          this.roomVisible=true;
        }
        if(i==2){
            this.batchVisible=true;
        }
        if(i==3){
          this.tabLabel = tabLabel;
        }
        // this.getRoomType(formData);
        // this.buttonsShow = false;

      }
    },
    //验证填写表单
    async validateForm(i){
      let isSubmit = await this.isSubmitForm();
      if(this.tabLabel===1&&!isSubmit){
        this.$message.error('请填写完整入住信息');
        return false;
      };
      if(this.tabLabel===2&&isSubmit.room_need&&isSubmit.room_need.length==0){
        this.$message.error('请添加一个用房需求');
        return false;
      };
      if(!isSubmit){
        return isSubmit;
      }
      this.formData = {...this.formData,...isSubmit};
      return i?true:isSubmit;
    },
    //确认订单
    async submitForm(){
      let isSubmit = await this.validateForm();
      let discount_need=[]
      //最少一个用房需求添加

      
      //修改时多判断一个优惠房
      if(this.modify||this.orderConfirmSend){
        // 对比原始数据和当前数据是否有变化
        let ComparativeData = {...this.formData,...isSubmit};
        const isModify = this.$_Array.deepEqual(this.orderInfo, ComparativeData);
        console.log(this.behalf);
        if(isModify&&this.behalf==0){
          this.$message({
            message: '您未修改任何内容',
            type: 'warning'
          });
          return;
        }
        //代订收款如果有未修改的内容、弹出确认框
        if(this.behalf>0){
          this._confirm('您未修改任何内容，是否确认订单？',() => {
              this.formData = {...this.formData,...isSubmit};
              this.$emit('submitForm',this.formData);
          }); 
          return 
        }
        discount_need=this.$refs.discount.submitForm();
        if(!discount_need) return
      }
      //确认订单弹出确认框
      if(isSubmit){
        this.formData = {...this.formData,...isSubmit};
        this.$emit('submitForm',this.formData);
      }
    },
    //判断当前需求是否填写完整
    async isSubmitForm(){
      if(this.tabLabel===1){
        let {isSubmit,formData} = await this.$refs.roomBasic.submitForm();       //调用基本信息确认方法
        if(isSubmit){ this.formData = {...this.formData,...formData}}
        return isSubmit
      }
      if(this.tabLabel===2){
        return this.$refs.roomType.submitForm();
      }
      if(this.tabLabel===3){
        return this.$refs.meetingType.submitForm();
      }
      if(this.tabLabel===4){
        return this.$refs.other.submitForm();
      }
      if(this.tabLabel===5){
        return this.$refs.discount.submitForm();
      }
    },
    //点击其他需求
    switchTabOther(index,tabLabel){
      this.requirementList[index].state=true;
    },
  }
};
</script>

<style lang="scss" scoped>
    .statusBar{
      // box-shadow: -2px 0 30px 2px rgba(97, 105, 119, 0.18);
      margin-top: 16px;
    }
    .room-Type{
        background-color: #fff;
        box-shadow: -2px 0 30px 2px rgba(97, 105, 119, 0.18);
        width: 94%;
        padding: 2% 3%;
        border-radius: 6px;
    }
    .text-ris{
      color: #999;
      margin-left: 12px;
    }
    .fillin{
      display: flex;
      justify-content:space-between;
      li{
        background-color: #fff;
        box-shadow: -2px 0 30px 2px rgba(97, 105, 119, 0.18);
        border-radius: 6px;
      }
      li:last-child {
        margin-right: 0;
        border-right: 0;
      }
      
    }
    .complete{
        width: 94%;
        display: flex;
        justify-content: space-between;
        margin-right: 16px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        >i{
          color: #999;
          font-size: 16px;
          margin-left: auto !important;
          display: inline-block;
        }
    }
    .room-bottom{
      width: 96%;
      padding: 2%;
      position: sticky;
      bottom: 0;
      left: 0 ;
      z-index: 9;
    }
    .choice-Room{
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
      li{
        margin-left: 14px;
        background-color: var(--smtc-color-TextBackground-grayBlue);
        padding: 10px 0;
        font-size: 14px;
        border-radius: 4px;
        cursor: pointer;
        width: 80px;
        img{
          width: 26px;
          margin-right: 8px;
          display: block;
          margin: 0 auto;
        }
        i{
          font-size: 16px;
        }
      }
      .choice-active{
        background-color: var(--smtc-color-primary);
        color: #fff;
      }
    }
    .fillin .text-active{
       background-color: var(--smtc-color-primary);
       color: #fff;
       i{
        color:#fff;
        font-size: 16px;
       }
    }
    .other{
            background-color: #fff;
            box-shadow: -2px 0 30px 2px rgba(97, 105, 119, 0.18);
            width: 94%;
            padding: 2% 3%;
            display: flex;
            justify-content: left;
            margin-top: 20px;
    }
    .other p{
        display: flex;
        justify-content: center;
        flex-direction: column;
    }
    .other-list{
        display: flex;
        li{
            margin-left: 14px;
            border: 1px dashed #999;
            padding: 4px 10px;
            font-size: 12px;
            border-radius: 4px;
            cursor: pointer;
        }
        .other-active{
            background-color: var(--smtc-color-primary);
            color: #fff;    
            border:1px solid var(--smtc-color-primary);
        }
    }
    .primary-button{
      display: flex;
      justify-content:space-between;
    }
    .category-item-icon{
      position: absolute;
      right: -20px;
      bottom: -20px;
      background-color: red;
      width: 40px;
      height: 40px;
      transform: rotate(45deg);
      z-index: 3;
      i{
        margin-left: -27px;
        margin-top: 13px;
        transform: rotate(-45deg);  
        font-size: 12px;
        font-weight: bold;
        color: #fff;
      }
    }
    .content{
      display: flex;
      width: 100%;
      padding: 16px 5%;
      justify-content: space-between;
    }
     .el-icon-delete-solid{
      color: red;
      margin-left: 14px;
      margin-top: 20px;
      font-size: 13px !important;
    }
</style>
<style>
  .el-popconfirm__action{
    margin-top: 10px;
  }
</style>